<template>
  <div>
    <div class="h-full">
      <div class="rounded bg-white grid grid-cols-12 " :style="`height:` +  mainHeight + `px; !important`">
        <div class=" mx-2 shadow-md relative" :class="isFilterOpen ? 'box col-span-10' : 'box col-span-12'">
          <div class="bg-white cust_card p-2 heading-3 text-text1 justify-between flex">
            <p>Reconciliation</p>
            <button @click="exportReport()" :class="firstLoading && reconcilianData !== null ? 'text-white bg-primary2 cursor-pointer' : 'cursor-not-allowed bg-gray-300 tet-text2 filter opacity-60'" style="letter-spacing: 1px;" class="px-2 cust_card heading-6 mr-8 flex items-center">
              <!-- <i class="fas fa-file-export h-5 w-5 text-white"></i> -->
              Export to Excel
            </button>
            <div class="top-0 absolute" :class="isFilterOpen ? '-right-4' : 'transition-all delay-75 -right-2'" >
              <button id="toggle" class="bg-gray-600 hover:bg-gray-700 transition delay-75 w-11 h-11 rounded-l-full " @click="openCloseFilter()">
                <span v-if="isFilterOpen"><i class="fas fa-caret-right h-6 w-6 text-white mt-1"></i></span>
                <p v-if="!isFilterOpen"><i class="fas fa-caret-left h-6 w-6 text-white mt-1"></i></p>
              </button>
            </div>
          </div>
          <div style="overflow-y: auto; white-space: nowrap;" class="table_containder" v-if="firstLoading">
            <div :style="`max-height:` +  cardHight + `px; !important`" class="pt-2">
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer  w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Accounts Receivable</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.accountsReceivale | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer bg-gray-50 w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Commissions</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.commissions | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer  w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Refunds</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.refunds | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer bg-gray-50 w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Sales Tax Payable</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.salesTaxPayables | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer  w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Shipping Revenue</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.shippingRevenue | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="min-w-min flex p-2 text-sm items-center py-1 cursor-pointer bg-gray-50 w-96">
                <div class="dates_col hover:bg-gray-50">
                  <span class="heading-5 text-text1">Revenue</span>
                </div>
                <div class="small_col hover:bg-gray-50 text-right">
                  <span class="heading-5 text-text2">{{reconcilianData.revenue | amountFormaterWithToFix}}</span>
                </div>
              </div>
              <div class="dividerLight w-96"></div>
            </div>
          </div>
          <div class="layout m-2" v-if="reconcilianData === null && firstLoading">
            <div class="flex p-3 text-sm text-primary2 bg-white border-blue-100 border-2 rounded-lg  items-center" role="alert">
              <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
              <span class="sr-only">Info</span>
              <div>
                <p class=" font-medium heading-4">No record found.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="box col-span-2 overflow-y-auto mx-2 shadow-md transition-transform delay-300 ease-in-out transition-2" :style="!isFilterOpen ? 'display: none' : ''">
          <GlobalFilter :callFrom="'Walmart'"  :callParent="'accounting'"  @closeFilter="closeFilter" :isFilterOpen="isFilterOpen"/>
        </div>
      </div>
    </div>
    <div class="bg-white container" v-if="showCustomDatepicker" >
      <div class="popup_overlay">
        <CustomDateSelector :appliedFilters="filterObject" @closeSelectedDialog="customDateListener" v-if="showCustomDatepicker"/>
      </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import {downloadFile} from '@/utils/common.js'
import moment from 'moment'
import API from '@/api/App.js'
import CustomDateSelector from '@/View/components/customDateSelection'
import GlobalFilter from '@/View/Admin/Components/filterWithoutSelection.vue'
// import Pagination from '@/View/components/pagination.vue'
export default {
  components: {
    GlobalFilter,
    CustomDateSelector,
  },
  data () {
    return {
      isFilterOpen: true,
      isRefresh: true,
      reconcilianData: null,
      selectAllCheck: false,
      parentListDisplay: [],
      requiredDataListing: [],
      filterObject: {
        startDate: '',
        endDate: '',
        minDate: '',
        maxDate: '',
      },
      dataBase: [],
      cardHight: 0,
      mainHeight: 0,
      defaultStartDate: '',
      defaultEndDate: '',
      showCustomDatepicker: false,
      firstLoading: false,
    }
  },
  created() {
  },
  beforeMount () {
  },
  mounted () {
    this.cardHight = window.innerHeight - 255
    this.mainHeight = window.innerHeight - 145
    console.log('this.cardHight', this.cardHight, this.mainHeight)
    this.defaultEndDate = new Date()
    let currentDate = new Date()
    this.defaultStartDate = new Date(currentDate.setDate(currentDate.getDate() - 29))
    this.filterObject.startDate = this.defaultStartDate
    this.filterObject.endDate = this.defaultEndDate
    console.log('this.defaultStartDate', this.defaultStartDate)
    console.log('this.defaultEndDate', this.defaultEndDate)
  },
  watch: {
    filterObject: {
      handler () {
        console.log('filterObject', this.filterObject)
      },
      deep: true
    },
  },
  methods: {
    openCloseFilter () {
      if (this.isFilterOpen) {
        this.isFilterOpen = false
      } else {
        this.isFilterOpen = true
      }
      console.log('openCloseFilter')
    },
    customDateListener (data) {
      console.log('datadatadatadatadatadata', data)
      this.showCustomDatepicker = false
      if (data !== null) {
        this.filterObject.startDate = data.startDate
        this.filterObject.endDate = data.endDate
      }
    },
    applyFilter() {
      this.getListing()
    },
    closeFilter (data) {
      console.log('data', data)
      this.filterObject.startDate = data.startDate
      this.filterObject.endDate = data.endDate
      this.getListing()
    },
    getListing () {
      this.firstLoading = false
      console.log('this.filterObject.startDate 123 123', this.filterObject.startDate)
      console.log('this.filterObject.endDate 123 123', this.filterObject.endDate)
      let utcSTART = moment(this.filterObject.startDate).format("YYYY-MM-DD");
      let utcEND = moment(this.filterObject.endDate).format("YYYY-MM-DD");
      this.$store.dispatch('SetLoader', {status: true, message: 'Please wait, it takes some time ...'})
      API.WalmartReconciliation(
        utcSTART,
        utcEND,
        false,
        response => {
          this.reconcilianData = response.Data === null ? null : response.Data
          console.log(response.Data)
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
          this.firstLoading = true
        },
        error => {
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    async exportReport () {
      if (this.firstLoading && this.reconcilianData !== null) {
        let utcSTART = moment(this.filterObject.startDate).format("YYYY-MM-DD");
        let utcEND = moment(this.filterObject.endDate).format("YYYY-MM-DD");
        let day1 = moment(this.filterObject.startDate).format("DD-MM-YY")
        let day2 = moment(this.filterObject.endDate).format("DD-MM-YY")
        let Time = 'Walmart Reconciliation' + day1 + '-To-' + day2
        let data = new FormData()
        data.append('from', utcSTART)
        data.append('to', utcEND)
        data.append('export', true)
        await this.downloadAttachment('api/v1/analytics/dpp/walmart/reconciliationInfo', `${Time}` + '.xlsx', data)
      }
    },
    async downloadAttachment (subUrl, fileName, formData) {
      let url = this.$store.getters.liveServerUrl + subUrl
      // If Want To cancel request
      const cancelToken = axios.CancelToken
      const source = cancelToken.source()
      let originalFileName = fileName
      this.$store.dispatch('CancelDownloadRequest', source)
      // Show loader while downloading
      this.$store.dispatch('SetDownloadLoader', true)
      // Calling Api and waiting for response
      let response = await downloadFile(formData, url, source)
      // Checking for status if 200 == success
      if (response.status === 200) {
        this.$store.dispatch('CancelDownloadRequest', null)
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        console.log(window.URL.createObjectURL(new Blob([response.data])))
        link.setAttribute('download', originalFileName)
        document.body.appendChild(link)
        link.click()
        // CLosing loader and reseting text in loader
        this.$store.dispatch('SetDownloadLoader', false)
        this.$store.dispatch('SetDownloadMessage', '')
      } else {
        this.$store.dispatch('CancelDownloadRequest', null)
        this.$store.dispatch('SetDownloadMessage', '')
        this.$store.dispatch('SetDownloadLoader', false)
      }
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>

.dates_col {
  min-width: 240px !important;
  width: 240px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}

.small_col {
  min-width: 134px !important;
  width: 134px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.overFlowParaA {
  word-break: break-all !important;
  white-space: initial !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
}

.large_col {
  min-width: 260px !important;
  width: 260px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}


</style>
